// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.dashboard-title {
  color: #002475;
  text-align: center;
  margin-bottom: 30px;
  font-size: 24px;
  font-weight: bold;
}

.dashboard-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Stats Sections */
.stats-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.stats-row {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.stat-card {
  background-color: white;
  border: 1px solid black;
  padding: 20px;
  flex: 1 1;
}

.supply-stats .stat-card {
  width: 50%;
  margin: 0;
}


.stat-label {
  color: #666;
  font-size: 14px;
}

.stat-value {
  color: var(--primary-color);
  font-size: 24px;
  font-weight: bold;
}

.stat-subtitle {
  color: #666;
  font-size: 12px;
}

/* Chart Sections */
.chart-section {
  background-color: white;
  padding: 10px 15px 0 15px;
  margin-bottom: 10px;
  overflow: hidden;
  border: none;
  box-shadow: none;
}

.chart-container {
  width: 100%;
  margin-bottom: 10px;
  overflow: hidden;
  border: none;
  box-shadow: none;
}

.charts-row {
  display: flex;
  gap: 10px;
  margin-top: 10px;
  width: 100%;
  overflow: hidden;
  border: none;
}

.half-width {
  width: 50%;
}

.chart-title {
  color: #002475;
  font-size: 18px;
  margin-bottom: 5px;
  text-align: center;
}

/* Tooltips */
.custom-tooltip {
  background-color: white;
  border-radius: 4px;
  padding: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.custom-tooltip p {
  margin: 0;
  padding: 4px 0;
  color: #333;
  font-size: 16 px;
}

/* Data Source */
.data-source {
  text-align: right;
  color: #666;
  font-size: 12px;
  margin-top: 20px;
}

.card-time-selector {
  margin-top: 8px;
  display: flex;
  justify-content: flex-end;
}

.chart-column {
  position: relative;
  min-height: 500px;
  /* Ensure enough space for labels */
}

.recharts-wrapper {
  margin: 0 auto;
}

.custom-tooltip {
  background-color: white;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  padding: 8px 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.custom-tooltip p {
  margin: 0;
  padding: 4px 0;
  white-space: nowrap;
}

.custom-tooltip {
  background-color: white;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  padding: 8px 12px;
}

.custom-tooltip p {
  margin: 0;
  padding: 4px 0;
  font-family: var(--app-font-family);
}

.custom-tooltip p:first-child {
  color: var(--primary-color);
  font-weight: bold;
}

.time-period-selector {
  padding: 4px 8px;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  background-color: white;
  color: var(--primary-color);
  font-size: 12px;
  cursor: pointer;
}

.time-period-selector:hover {
  background-color: #f5f5f5;
}

.time-period-selector:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(0, 36, 117, 0.2);
}

.stat-card {
  background-color: white;
  border: 1px solid black;
  padding: 20px;
  flex: 1 1;
  position: relative;
}

.time-selector {
  min-width: 80px;
}

.time-selector select {
  padding: 4px 8px;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  font-size: 12px;
  background-color: white;
  cursor: pointer;
}

.stat-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}

/* Add these to your existing CSS */
.selector-container {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.time-period-selector {
  padding: 8px 16px;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  background-color: white;
  color: var(--primary-color);
  font-family: var(--app-font-family);
  cursor: pointer;
}

.time-period-selector:hover {
  background-color: #f5f5f5;
}

.time-period-selector:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(0, 36, 117, 0.2);
}

/* Responsive Design */
@media (max-width: 768px) {
  .stats-row {
    flex-direction: column;
  }

  .charts-row {
    flex-direction: column;
  }

  .half-width {
    width: 100%;
  }

  .supply-stats .stat-card {
    width: 100%;
  }
}

.charts-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.charts-row {
  display: flex;
  gap: 15px;
  width: 100%;
}

.chart-column {
  flex: 1 1;
  min-width: 0;
  /* Prevents flex items from overflowing */
}

.chart-title {
  color: #002475;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 15px;
  text-align: center;
}

/* Remove any margin/padding from chart containers */
.recharts-wrapper {
  margin: 0 !important;
  padding: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/HypeBurn.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,SAAO;AACT;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;;AAGA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2CAA2C;AAC7C;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,oDAAoD;AACpD;EACE,oBAAoB;EACpB,qBAAqB;AACvB","sourcesContent":[".dashboard {\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.dashboard-title {\n  color: #002475;\n  text-align: center;\n  margin-bottom: 30px;\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.dashboard-content {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n/* Stats Sections */\n.stats-section {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.stats-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.stat-card {\n  background-color: white;\n  border: 1px solid black;\n  padding: 20px;\n  flex: 1;\n}\n\n.supply-stats .stat-card {\n  width: 50%;\n  margin: 0;\n}\n\n\n.stat-label {\n  color: #666;\n  font-size: 14px;\n}\n\n.stat-value {\n  color: var(--primary-color);\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.stat-subtitle {\n  color: #666;\n  font-size: 12px;\n}\n\n/* Chart Sections */\n.chart-section {\n  background-color: white;\n  padding: 10px 15px 0 15px;\n  margin-bottom: 10px;\n  overflow: hidden;\n  border: none;\n  box-shadow: none;\n}\n\n.chart-container {\n  width: 100%;\n  margin-bottom: 10px;\n  overflow: hidden;\n  border: none;\n  box-shadow: none;\n}\n\n.charts-row {\n  display: flex;\n  gap: 10px;\n  margin-top: 10px;\n  width: 100%;\n  overflow: hidden;\n  border: none;\n}\n\n.half-width {\n  width: 50%;\n}\n\n.chart-title {\n  color: #002475;\n  font-size: 18px;\n  margin-bottom: 5px;\n  text-align: center;\n}\n\n/* Tooltips */\n.custom-tooltip {\n  background-color: white;\n  border-radius: 4px;\n  padding: 12px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.custom-tooltip p {\n  margin: 0;\n  padding: 4px 0;\n  color: #333;\n  font-size: 16 px;\n}\n\n/* Data Source */\n.data-source {\n  text-align: right;\n  color: #666;\n  font-size: 12px;\n  margin-top: 20px;\n}\n\n.card-time-selector {\n  margin-top: 8px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.chart-column {\n  position: relative;\n  min-height: 500px;\n  /* Ensure enough space for labels */\n}\n\n.recharts-wrapper {\n  margin: 0 auto;\n}\n\n.custom-tooltip {\n  background-color: white;\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  padding: 8px 12px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.custom-tooltip p {\n  margin: 0;\n  padding: 4px 0;\n  white-space: nowrap;\n}\n\n.custom-tooltip {\n  background-color: white;\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  padding: 8px 12px;\n}\n\n.custom-tooltip p {\n  margin: 0;\n  padding: 4px 0;\n  font-family: var(--app-font-family);\n}\n\n.custom-tooltip p:first-child {\n  color: var(--primary-color);\n  font-weight: bold;\n}\n\n.time-period-selector {\n  padding: 4px 8px;\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  background-color: white;\n  color: var(--primary-color);\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.time-period-selector:hover {\n  background-color: #f5f5f5;\n}\n\n.time-period-selector:focus {\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(0, 36, 117, 0.2);\n}\n\n.stat-card {\n  background-color: white;\n  border: 1px solid black;\n  padding: 20px;\n  flex: 1;\n  position: relative;\n}\n\n.time-selector {\n  min-width: 80px;\n}\n\n.time-selector select {\n  padding: 4px 8px;\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  font-size: 12px;\n  background-color: white;\n  cursor: pointer;\n}\n\n.stat-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 8px;\n}\n\n/* Add these to your existing CSS */\n.selector-container {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 20px;\n}\n\n.time-period-selector {\n  padding: 8px 16px;\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  background-color: white;\n  color: var(--primary-color);\n  font-family: var(--app-font-family);\n  cursor: pointer;\n}\n\n.time-period-selector:hover {\n  background-color: #f5f5f5;\n}\n\n.time-period-selector:focus {\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(0, 36, 117, 0.2);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .stats-row {\n    flex-direction: column;\n  }\n\n  .charts-row {\n    flex-direction: column;\n  }\n\n  .half-width {\n    width: 100%;\n  }\n\n  .supply-stats .stat-card {\n    width: 100%;\n  }\n}\n\n.charts-container {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.charts-row {\n  display: flex;\n  gap: 15px;\n  width: 100%;\n}\n\n.chart-column {\n  flex: 1;\n  min-width: 0;\n  /* Prevents flex items from overflowing */\n}\n\n.chart-title {\n  color: #002475;\n  font-size: 16px;\n  font-weight: 500;\n  margin-bottom: 15px;\n  text-align: center;\n}\n\n/* Remove any margin/padding from chart containers */\n.recharts-wrapper {\n  margin: 0 !important;\n  padding: 0 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
